import {
  VALIDATION_TYPE,
  ValidationType,
} from '@framework/engine/validator/form-builder/types/FormBuilderTypes.ts';
import { useHandleSubmit } from '@framework/form/form/submit/useHandleSubmit.ts';

interface IHandleDraftSubmitParams {
  onValid: (data: any) => Promise<void>;
}

/**
 * Ritorna la funzione per gestire il submit del form in modalità draft.
 * Simula il submit del form usando le funzioni principali.
 * La validazione in draft richiede un approccio diverso rispetto alla validazione parziale/totale,
 * e front-end possiamo prendere come presupposto che i dati contenuti siano strutturalmente validi
 * e che per la bozza non sia necessaria una validazione profonda, lasciando questo compito al BE.
 *
 * Andiamo quindi a fare un check "superficiale" e a gestire solo un subset minimo delle operazioni gestite
 * da methods.handleSubmit.
 *
 */
export function useHandleDraftSubmit(params: IHandleDraftSubmitParams) {
  return useHandleSubmit({
    onValid: params.onValid,
    extraContext: { [VALIDATION_TYPE]: ValidationType.DRAFT },
  });
}
